import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const microsoftOneDrive = defineConnector({
  identifier: "microsoftOneDrive",
  name: "Microsoft OneDrive",
  tagLine: "Cloud storage and file sharing",
  keywords: "skydrive office 365 m365 graph cloud storage files folders",
  logo,
  protocol: "http",
  tags: ["productivity", "documents"],
  defaultUrlPattern: () => "https://graph\\.microsoft\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Connect your Microsoft OneDrive account",
      items: [
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
    tokenEndpoint: () =>
      "https://login.microsoftonline.com/common/oauth2/v2.0/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "env",
    credentialsServiceType: "microsoft-onedrive",
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://graph.microsoft.com/v1.0/me/drive",
  },
});
